export * from "./demarcation-list-template.component";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/demarcation/index.ts